import { get } from '../utils/APIClient';

export const getAssignment = ({ assignmentId, token }) => {
  return get({ url: `assignments/${assignmentId}`, token });
};
